// extracted by mini-css-extract-plugin
module.exports = {"button":"SubmitButton_button__Sa4qu","bgPos":"SubmitButton_bgPos__ynqTi"};